import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
export function ComparisonTable() {
  const badPoints = ['Prueba y error constante con los materiales', 'Gasta dinero en luces LED equivocadas', 'No logra el efecto de profundidad infinita', 'Termina con acabados poco profesionales', 'Cobra barato porque no confía en su trabajo'];
  const goodPoints = ['Sigue un paso a paso probado y exacto', 'Compra los materiales correctos a la primera', 'Logra un efecto infinito perfecto y realista', 'Consigue acabados premium de alta calidad', 'Vende sus piezas a precios de alto valor'];
  return <section className="py-12 px-4 relative z-10 bg-[#0a0514]" data-id="element-61">
      <div className="max-w-6xl mx-auto" data-id="element-62">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-[#130a2a] border border-[#27272a] rounded-2xl p-8 md:p-10" data-id="element-63">
          <div className="mb-8 border-b border-[#27272a] pb-6 relative z-10" data-id="element-64">
            <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-red-500/10 text-red-400 text-xs font-bold mb-3" data-id="element-65">
              <XIcon className="w-3 h-3" data-id="element-66" /> EL ERROR
            </div>
            <h3 className="text-2xl font-bold text-gray-300" data-id="element-67">Persona Normal</h3>
            <p className="text-gray-500 mt-2 text-sm" data-id="element-68">
              Pierde tiempo y materiales
            </p>
          </div>
          <ul className="space-y-5" data-id="element-69">
            {badPoints.map((point, i) => <li key={i} className="flex items-start gap-4 text-gray-400" data-id="element-70">
                <div className="bg-red-500/10 p-1.5 rounded-lg shrink-0 mt-0.5" data-id="element-71">
                  <XIcon className="w-4 h-4 text-red-400" data-id="element-72" />
                </div>
                <span className="leading-relaxed" data-id="element-73">{point}</span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="bg-[#130a2a] border border-[#00f0ff]/30 rounded-2xl p-8 md:p-10 relative overflow-hidden shadow-[0_8px_30px_rgba(0,240,255,0.05)]" data-id="element-74">
          {/* Glow effect */}
          <div className="absolute -top-24 -right-24 w-48 h-48 bg-[#00f0ff]/20 rounded-full blur-3xl" data-id="element-75" />
          <div className="absolute top-0 right-0 w-64 h-64 bg-[#00f0ff]/5 blur-[60px] rounded-full pointer-events-none" data-id="element-76" />

          <div className="mb-8 border-b border-[#27272a] pb-6 relative z-10" data-id="element-77">
            <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-[#00f0ff]/10 text-[#00f0ff] text-xs font-bold mb-3" data-id="element-78">
              <CheckIcon className="w-3 h-3" data-id="element-79" /> EL OBJETIVO
            </div>
            <h3 className="text-2xl font-bold text-white" data-id="element-80">
              Maestro de la Ilusión
            </h3>
            <p className="text-gray-400 mt-2 text-sm" data-id="element-81">
              Crea piezas de alto valor
            </p>
          </div>
          <ul className="space-y-5 relative z-10" data-id="element-82">
            {goodPoints.map((point, i) => <li key={i} className="flex items-start gap-4 text-gray-200 font-medium" data-id="element-83">
                <div className="bg-[#00f0ff]/10 p-1.5 rounded-lg shrink-0 mt-0.5" data-id="element-84">
                  <CheckIcon className="w-4 h-4 text-[#00f0ff]" data-id="element-85" />
                </div>
                <span className="leading-relaxed" data-id="element-86">{point}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}